import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { SWRConfig } from "swr";
import * as Sentry from "@sentry/react";
import App from "./App";
import posthog from "posthog-js";
import { PostHogProvider, PostHogErrorBoundary } from "posthog-js/react";

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  ui_host: "https://us.posthog.com",
  defaults: "2025-05-24",
});

Sentry.init({
  dsn: import.meta.env.VITE_GLITCHTIP_DSN,
  environment: import.meta.env.MODE,
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <PostHogErrorBoundary>
        <BrowserRouter>
          <Suspense fallback="Cargando...">
            <SWRConfig
              value={{
                onError: (error, key) => {
                  const status = error?.response?.status;
                  $log.error("SWR request failed", { key, status, error });
                  if (status === 403 && typeof key === "string" && key.startsWith("property/")) {
                    if (!window.location.pathname.includes("/subscription")) {
                      window.location.assign("/subscription");
                    }
                  }
                },
                onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
                  const status = error?.response?.status;
                  if (status === 401 || status === 403) return;

                  if (retryCount >= 2) return;
                  setTimeout(() => revalidate({ retryCount: retryCount + 1 }), 1500);
                },
              }}
            >
              <App />
            </SWRConfig>
          </Suspense>
        </BrowserRouter>
      </PostHogErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>,
);
